export const convertHtmlToWhatsappText = (html: string): string => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
  
    let text = temp.innerHTML;
  
    // שורות חדשות
    text = text.replace(/<br\s*\/?>/gi, "\n");
    text = text.replace(/<\/p>/gi, "\n");
  
    // הדגשה מודגשת: <b>, <strong> → *טקסט*
    text = text.replace(/<(b|strong)>(.*?)<\/\1>/gi, "*$2*");
  
    // נטוי: <i>, <em> → _טקסט_
    text = text.replace(/<(i|em)>(.*?)<\/\1>/gi, "_$2_");
  
    // קו תחתון: <u> → _טקסט_
    text = text.replace(/<u>(.*?)<\/u>/gi, "_$1_");
  
    // קו חוצה: <s>, <strike>, <del> → ~טקסט~
    text = text.replace(/<(s|strike|del)>(.*?)<\/\1>/gi, "~$2~");
  
    // הסרת תגיות נוספות
    text = text.replace(/<[^>]+>/g, "");
  
    return text.trim();
  };